import { BodyText, RadioTile, RadioGroup } from "@utilitywarehouse/hearth-react";

import { ConfirmationAnswer } from "../../context/vulnerability/VulnerabilityContext";
import { QuestionsDataTest } from "../Questions/constants";

export interface MultiChoiceSelectProps {
  value?: ConfirmationAnswer;
  requireAnswer?: boolean;
  hasError?: boolean;
  onChange: (answer: ConfirmationAnswer) => void;
}

const MultiChoiceSelect: React.FC<MultiChoiceSelectProps> = ({
  value,
  requireAnswer,
  hasError,
  onChange,
}) => {
  const handleChange = ((value: string) => {
    onChange(value as ConfirmationAnswer);
  });

  return (
    <RadioGroup
      aria-label="confirm question"
      name="confirm question-buttons-group"
      onValueChange={handleChange}
      value={value ?? null}
      validationStatus={hasError ? "invalid" : undefined}
      validationPlacement="bottom"
      validationText={
        <BodyText
          data-testid={QuestionsDataTest.ERROR}
        >
          Please select a response to continue
        </BodyText>
      }
      direction="row"
    >
      <RadioTile
        flex="1"
        label={ConfirmationAnswer.Yes}
        value={ConfirmationAnswer.Yes}
        data-testid={QuestionsDataTest.YES_BTN}
      />
        
      <RadioTile
        flex="1"
        label={ConfirmationAnswer.No}
        value={ConfirmationAnswer.No}
        data-testid={QuestionsDataTest.NO_BTN}
      />

      {!requireAnswer ? (
        <RadioTile
          flex="1"
          label="Skip this question"
          value={ConfirmationAnswer.Skip}
          data-testid={QuestionsDataTest.SKIP_BTN}
        />
      ) : null}
    </RadioGroup>
  )
};

export default MultiChoiceSelect;
